<template>
	<div>
		<dl class="opport-screen bdbe">
			<dt class="fl">{{provinceName}}</dt>
			<dd class="fl">
				<span :class="provinceid == 0?'current a-screen':'a-screen'"
					@click="provincechoose(0,'all');  ">全国地区</span>
				<span :key="index" v-for="(item,index) in provincedata"
					@click="provincechoose(item.areaId,index); "
					:class="item.areaId == provinceid?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					<span class="fr pt display-inlineblock" v-if="isShowTips"><vedioTips :type="showTipsType"></vedioTips></span>
					
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="citydata.length!=0">
			<dt class="fl">城市地区</dt>
			<dd class="fl">
				<span :class="cityid == 0?'current a-screen':'a-screen'"
					@click="choosecity(0,'all'); ">全部</span>
				<span :key="index" v-for="(item,index) in citydata"
					@click="choosecity(item.areaId,index);cityid=item.areaId; "
					:data="item.areaId"
					:class=" item.areaId == cityid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="countydata.length!=0 && isShowCounty">
			<dt class="fl">区县地区</dt>
			<dd class="fl">
				<span :class="countyid == 0?'current a-screen':'a-screen'"
					@click="choosecounty(0); ">全部</span>
				<span :key="index" v-for="(item,index) in countydata"
					@click="choosecounty(item.areaId);countyid=item.areaId; "
					:data="item.areaId"
					:class=" item.areaId == countyid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
			</dd>
		</dl>
	</div>
</template>

<script>
	import { dataInJs } from "../../utils/city.js";
	export default {
		name: 'enterpriseList',
		data() {
			return {
				provinceid: 0,
				cityid: 0,
				countyid: 0,
				provincedata: dataInJs(),
				citydata: [],
				countydata: [],
			}},
		props:{ 
			isShowCounty:{type:Boolean,default:true},  
			provinceName:{type:String,default:'省份地区'},
			isShowTips:{type:Boolean,default:false}, //是否显示提示视频文字
			showTipsType:{type:Number,default:3}, //提示视频的类型
		},
		methods:{
			//省份城市选择
			provincechoose(id, i) {
				if (this.provinceid != id) { 
					// this.cleartNotion();
					this.cityid = 0;
					this.countyid = 0; 
					this.provinceid = id;
					this.countydata = [];
					if (i != "all" && this.provincedata[i].children != null) {
						this.citydata = this.provincedata[i].children;
					} else {
						this.citydata = [];
					}
				 this.$emit('getEnterpriseList',this.provinceid,	this.cityid,this.countyid);
				}
			},
			
			choosecity(id, i) {
				//	console.log('choosecity',id);
				if (this.cityid != id) { 
					this.cityid = id;
					this.countyid = 0;
					if (i != "all" && this.citydata[i].children != null) {
						this.countydata = this.citydata[i].children;
					} else {
						this.countydata = [];
					} 
					this.$emit('getEnterpriseList',this.provinceid,	this.cityid,this.countyid); 
				}
			},
			choosecounty(id) { 
				this.countyid = id; 
				this.$emit('getEnterpriseList',this.provinceid,	this.cityid,this.countyid); 
			},
		}
	}
</script>

<style>
</style>